import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-building-05',
  imports: [],
  templateUrl: './building-05.html',
  styleUrl: './building-05.scss',
})
export class Building05 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
